module.exports = __webpack_public_path__ + "img/clubcard-loyalty-bg.aacb4267.svg";